import { emailSignatureService, emailTemplatesService, profileService } from 'config/api';
import { DEFAULT_USER_IMAGE_MAP, DIGITAL_STYLIST_GROUPS } from 'constants/index';
import omit from 'lodash/omit';
import actionTypes from './actionTypes';

const hasNMVIPGroup = (groups) => groups.some((group) => DIGITAL_STYLIST_GROUPS.indexOf(group) !== -1);

export const getEmailSignature =
  ({ brand = '', email = '', groups }) =>
  async (dispatch) => {
    dispatch({ type: actionTypes.GET_CURRENT_ASSOCIATE_EMAIL_SIGNATURE_STARTED });
    try {
      const { data } = await emailSignatureService.get();
      const profileAvatar = hasNMVIPGroup(groups) ? 'NMVIP' : brand;
      const templateObj = { ...data };
      const initialValues = { ...data };

      //set default value of useOffice365Photo and showEmailAddress to true
      templateObj.useOffice365Photo = true;
      initialValues.useOffice365Photo = true;
      templateObj.showEmailAddress = true;
      initialValues.showEmailAddress = true;
      templateObj.photoUrl = data?.office365PhotoUrl
        ? data?.office365PhotoUrl
        : `${window.location.origin}${DEFAULT_USER_IMAGE_MAP[profileAvatar]}`;

      templateObj.email = email;
      const templateData = await emailTemplatesService.post('/email-signature', { payload: templateObj }, {});
      const previewTemplate = templateData?.data?.layout;
      const payload = {
        ...initialValues,
        previewTemplate,
        templateData: templateObj,
      };

      dispatch({ type: actionTypes.GET_CURRENT_ASSOCIATE_EMAIL_SIGNATURE_SUCCESS, payload });
    } catch (error) {
      dispatch({ type: actionTypes.GET_CURRENT_ASSOCIATE_EMAIL_SIGNATURE_FAILED });
    }
  };

export const setEmailSignature =
  ({ formValues, brand = '', email = '', groups }) =>
  async (dispatch) => {
    dispatch({ type: actionTypes.SET_ASSOCIATE_EMAIL_SIGNATURE_STARTED });

    const profileAvatar = hasNMVIPGroup(groups) ? 'NMVIP' : brand;
    const formattedFormValues = omit(formValues, ['saCloudinaryImages']);

    try {
      const { data } = await emailSignatureService.post('', { ...formattedFormValues });
      const templateObj = { ...formattedFormValues };
      if (formattedFormValues?.useOffice365Photo && formattedFormValues?.office365PhotoUrl) {
        templateObj.photoUrl = data?.office365PhotoUrl;
      } else {
        templateObj.photoUrl = `${window.location.origin}${DEFAULT_USER_IMAGE_MAP[profileAvatar]}`;
      }

      templateObj.email = email;
      const templateData = await emailTemplatesService.post('/email-signature', { payload: templateObj }, {});
      const previewTemplate = templateData?.data?.layout;
      const payload = {
        ...data,
        previewTemplate,
      };

      dispatch({ type: actionTypes.SET_ASSOCIATE_EMAIL_SIGNATURE_SUCCESS, payload });
    } catch (error) {
      dispatch({ type: actionTypes.SET_ASSOCIATE_EMAIL_SIGNATURE_FAILED });
    }
  };

export const uploadProfileImage = (imageType, file, uploadToCloudinary) => async (dispatch, getState) => {
  const { pin } = getState().user.data;

  try {
    dispatch({ type: actionTypes.SET_ASSOCIATE_EMAIL_SIGNATURE_STARTED });

    const { secure_url: imageCloudinaryUrl, public_id: imagePublicId } = await uploadToCloudinary([file], imageType);

    await profileService.post('/user/images', {
      associatePin: pin,
      imageType,
      imageCloudinaryUrl,
      imagePublicId,
    });

    const { data } = await emailSignatureService.get();

    const payload = {
      ...data,
      saCloudinaryImages: data.saCloudinaryImages,
    };

    dispatch({ type: actionTypes.SET_ASSOCIATE_EMAIL_SIGNATURE_SUCCESS, payload });

    return imageCloudinaryUrl;
  } catch (error) {
    dispatch({ type: actionTypes.SET_ASSOCIATE_EMAIL_SIGNATURE_FAILED });
  }
};

export const removeProfileImage =
  ({ imageType }) =>
  async (dispatch, getState) => {
    const { pin } = getState().user.data;
    const { data } = getState().clientingModule.emailSettings;

    const payload = {
      ...data,
      saCloudinaryImages: {
        ...data.saCloudinaryImages,
        [imageType]: [],
      },
    };

    try {
      dispatch({ type: actionTypes.SET_ASSOCIATE_EMAIL_SIGNATURE_STARTED });
      await profileService.delete('/user/images', {
        data: {
          associatePin: pin,
          imageType,
          imagePublicId: data?.saCloudinaryImages?.[imageType]?.imagePublicId,
        },
      });
      dispatch({ type: actionTypes.SET_ASSOCIATE_EMAIL_SIGNATURE_SUCCESS, payload });
    } catch (error) {
      dispatch({ type: actionTypes.SET_ASSOCIATE_EMAIL_SIGNATURE_FAILED });
    }
  };
